import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { DataTable, DataTableRowClickEvent } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import {
  formatDateTime,
  parseQueryString,
  toQueryString,
} from "../../common/utils";
import { usePlacementEnvironmentTemplates } from "../../api/queries/placement-environment-template/usePlacementEnvironmentTemplates";
import { PlacementEnvironmentTemplateListItem } from "../../api/types/placement-environment-template";

export default function PlacementEnvironmentTemplateList() {
  const navigate = useNavigate();
  const queryParams = parseQueryString(useLocation().search);
  const limit = 20;
  const [offset, setOffset] = useState(0);
  const [total, setTotal] = useState(0);
  const [sortField, setSortField] = useState(queryParams.sortField);
  const [sortOrder, setSortOrder] = useState(queryParams.sortOrder);
  const onPage = (event: any) => setOffset(event.first);
  const onSort = (event: any) => {
    setSortField(event.sortField);
    setSortOrder(event.sortOrder);
  };

  const { data: placementEnvironmentTemplates, isLoading } =
    usePlacementEnvironmentTemplates({
      limit,
      offset,
    });

  const tName = (row: PlacementEnvironmentTemplateListItem) => row.name || "";

  const tDescription = (row: PlacementEnvironmentTemplateListItem) =>
    row.description || "";

  const tInstitutions = (row: PlacementEnvironmentTemplateListItem) =>
    row.institutions.map((institution) => institution.name).join(", ");

  const tContext = (row: PlacementEnvironmentTemplateListItem) =>
    row.context.name;

  const tCreatedAt = (row: PlacementEnvironmentTemplateListItem) =>
    formatDateTime(row.created_at);

  const onRowClick = (event: DataTableRowClickEvent) =>
    navigate(`/journey-tracker-templates/${event.data.id}`);

  useEffect(() => {
    const queryParamsStr = toQueryString({
      limit,
      offset,
      sortField,
      sortOrder,
    });
    navigate({ search: queryParamsStr });
  }, [offset, navigate, sortField, sortOrder]);

  useEffect(() => {
    setTotal(placementEnvironmentTemplates?.data.total_count || 0);
  }, [placementEnvironmentTemplates]);

  return (
    <div className={"col-12"}>
      <div className="flex py-3">
        <h1 className="m-0">Journey Tracker Template</h1>

        <Button
          onClick={() => navigate("/journey-tracker-templates/new")}
          className="p-button p-button-main p-button-sm ml-auto"
          label="Add new"
        />
      </div>

      <DataTable
        emptyMessage={"No records"}
        paginator={true}
        lazy={true}
        rows={limit}
        first={offset}
        totalRecords={total}
        loading={isLoading}
        sortField={sortField}
        sortOrder={sortOrder}
        onPage={onPage}
        onSort={onSort}
        className="p-datatable-sm p-datatable-pointer"
        onRowClick={onRowClick}
        stripedRows={true}
        value={placementEnvironmentTemplates?.data.results || []}
      >
        <Column header={"Name"} body={tName} />

        <Column header={"Description"} body={tDescription} />

        <Column header={"Institutions"} body={tInstitutions} />

        <Column header={"Context"} body={tContext} />

        <Column header={"Created at"} body={tCreatedAt} />
      </DataTable>
    </div>
  );
}
